import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DpadZoneType, ROUTE_PATH } from '@core/constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'caremoni-sub-header',
  templateUrl: './subheader.component.html',
  styleUrl: './subheader.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SubheaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() title: string = 'Screen 1';
  @Input() menuIcon: string = 'check-sheet';
  @Output() onExpandBody = new EventEmitter();
  DpadZoneType = DpadZoneType;
  isShowUITheme = false;
  isShowExpand = true;
  allowChangeThemeScreens: string[] = [
    `${ROUTE_PATH.CHECK_SHEET}`,
    `${ROUTE_PATH.USER_DASHBOARD}`,
    `${ROUTE_PATH.BATHING_SCHEDULE}`,
    `${ROUTE_PATH.EXCRETION_MONITOR}`,
    `${ROUTE_PATH.BATHING_SCHEDULE}`,
    `${ROUTE_PATH.TITLE_SETTINGS}`,
    `${ROUTE_PATH.BATHE_MANAGEMENT}`
  ];

  routerSubscription!: Subscription;
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe(event => {
        this.updateShowUITheme();
    });
    this.updateShowUITheme();
    
  }
  ngOnDestroy(): void { 
    if(this.routerSubscription) this.routerSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isShowExpand = true;
    if(this.router.url.includes(ROUTE_PATH.TITLE_SETTINGS)) this.isShowExpand = false;
    if(changes && changes['title']) {
      this.isShowUITheme = this.allowChangeThemeScreens.includes(changes['title'].currentValue);
    }
  }

  updateShowUITheme() {
    this.route.paramMap.subscribe(params => {
      const currentUrl = this.router.url.replace(/^\//, '');
      this.isShowUITheme = this.allowChangeThemeScreens.some(
        path => currentUrl === path || currentUrl.startsWith(path + '/')
      );
    });
  }

  onExpand() {
    this.onExpandBody.emit(true);
  }
}
